<template>
    <div class="not-found-container">

        <h1>Sorry, Page Not Found</h1>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>

    .not-found-container {
        padding-top: 20vh;
        padding-left: 10vw;
        padding-bottom: 40vh;

        background-image: url("../assets/background.png");
        background-repeat: no-repeat;
        background-position-y: 10vh;
        background-position-x: 64vw;
        background-size: 40%;
    }
    .inside-container{

    }
</style>